/* global define */

define('views/DropdownView',[
	'jquery',
	'underscore',
	'backbone',
	'text!templates/views/Dropdown.html'
], function($, _, Backbone, dropdownTemplate) {

	'use strict';

	var Control = Backbone.View.extend({
		id: null,
		values: null,
		defaultValue: null,
		defaultTitle: null,
		events: {
			'click li.controlValue': 'onClick'
		},
		initialize: function() {
			this.defaultValue = this.options.value;
			this.defaultTitle = this.options.title;
		},
		reset: function() {
			this.options.title = this.defaultTitle;
			this.options.value = this.defaultValue;

			this.trigger('change', {
				value: this.options.value,
				title: this.options.title,
				dropdown: this,
				options: this.options
			});

			this.render();
		},
		clear: function() {
			this.options.title = this.options.title;
			this.options.value = null;
			this.render();
		},
		getValue: function() {
			var value = this.options.value;
			if(value !== undefined && value !== null){
				return value;
			}
			return '';
		},
		getName: function() {
			return this.options.name;
		},
		onClick: function(event) {

			var $a = $(event.target),
				$li = $a.parent(),
				option = this.options.options[$li.data('index')];

			if (option.disabled !== undefined && option.disabled) {
				event.stopPropagation();
				return;
			}

			var title = $a.data('name'),
				value = $a.data('value');

			this.options.title = title;
			this.options.value = value;

			this.trigger('change', {
				value: this.options.value,
				title: this.options.title,
				dropdown: this,
				options: this.options
			});

			this.render();

		},
		getOptions: function(){
			return this.options.options;
		},
		addOption: function(newOption, select){
			this.options.options.push(newOption);

			if(select){
				this.options.value = newOption.value;
			}

			this.render();
		},
		render: function() {

			this.$el.html('');

			var align = 'left',
				alignMenu = align,
				title = 'unknown',
				options = [],
				value,
				i = 0;

			if (this.options.options) {
				options = this.options.options;
			}

			if (this.options.value) {

				var found = false;

				for (i = 0; i < options.length; i++) {

					value = options[i];
					if (value.value === this.options.value) {
						title = value.name;
						found = true;
						break;
					}

				}

				if(!found){

					if(this.options.name === 'PRICE'){

						title = this.options.value;
						title = title.replace(/000\-/g, 'k-');
						title = '$' + title;

						if(title.endsWith('000')){

							title = title.substring(0, title.length - 3) + 'k';

						}


					}
					else if(this.options.name === 'YEAR_BUILT'){

						title = this.options.value;
						title = title.replace(/000\-/g, 'k-');
						title = title;
						
					}

				}

			} else if (this.options.title) {
				title = this.options.title;
			}

			if (this.options.align) {
				align = this.options.align;
				alignMenu = this.options.alignMenu;
			}

			if (this.options.alignMenu){
				alignMenu = this.options.alignMenu;
			}

			// Clean up title
			if (title.endsWith(':')) {
				title = title.substring(0, title.length - 1);
			}

			var control = _.template($.trim(dropdownTemplate), {
				title: title,
				align: align,
				alignMenu:alignMenu
			});

			var $control = $(control);

			var $ul = $control.find('ul.dropdown-menu'),
				$li,
				$a,
				selected,
				disabled;

			if(this.options.bottomUp){
				$ul.addClass('bottom-up');
			}

			$li = $('<li class="controlTitle">' + this.defaultTitle + '</li>');
			$ul.append($li);

			for (i = 0; i < options.length; i++) {
				value = options[i];

				if (value.name === '----') {
					$li = $('<li class="divider"></li>');
					$ul.append($li);
					continue;
				}

				disabled = value.disabled;
				selected = this.options.value === value.value;

				$li = $('<li class="controlValue"><a href="javascript:void(0);"></a></li>');
				$li.data('index', i);

				if (disabled) {
					$li.addClass('disabled');
				}
				if (selected) {
					$li.addClass('active');
				}

				$a = $li.find('a');
				$a.text(value.name);
				$a.data('name', value.name);
				$a.data('value', value.value);
				$ul.append($li);
			}

			if(this.defaultTitle.indexOf(title) === -1){
				$control.attr('title', this.defaultTitle + ' ' + title);
			}
			else{
				$control.attr('title', this.tile);
			}

			this.$el.append($control);
			this.$el.find('a.dropdown-title').css('max-width', (this.options.width + 15) + 'px');
			//this.$el.find('div.dropdown-title').css('max-width', (this.options.width - 10) + 'px');
			//this.$el.find('.dropdown-title').css('min-width', (this.options.width + 5) + 'px');
			//this.$el.find('.dropdown-title').css('width', (this.options.width + 5) + 'px');

			var maxHeight = $(window).height() - 50;

			this.$el.find('.dropdown-menu').css('max-height', maxHeight + 'px').css('overflow', 'auto');

			return this;
		}
	});

	return Control;
});
